import { render } from "./Employee75Liquidations.vue?vue&type=template&id=f56a7ab6"
import script from "./Employee75Liquidations.vue?vue&type=script&lang=js"
export * from "./Employee75Liquidations.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__